module.exports = __webpack_public_path__ + "img/Misi Working Style-Icon Enterprising0.03627fbc.png";